import React from 'react';
import virtualacc from "../../../Assets/virtualacc.svg";

const ServiceItem = props => {
    let item = props.data;

    return (
        <div className="adg-container">
            <div className="adg-header">
                {item.title}
            </div>
            <div className="adg-container-data">
                <div className="adg-data">
                    {item.itemDesc.map((pItem, pIndex)=> {
                        return (
                            <p key={''+pIndex}>{pItem}</p>
                        );
                    })}
                </div>
                <div className="adg-container-banner">
                    <img src={item.banner} alt="work-img"/>
                </div>
            </div>
        </div>
    );
};

export default ServiceItem;


// WEBPACK FOOTER //
// ./src/Components/ServicesPage/SubServiceItem/ServiceItem.js